import * as yup from 'yup';

export default {
  // VALIDATE AMOUNT, DISCO, METER, ORDER ID, PAYMENT TYPE, PHONE NUMBER, VEND TYPE, VERTICAL
  batchOrderItemSchema: yup.object().shape({
    'Order Id': yup
      .string()
      .trim()
      .required('Order ID must be a non empty string'),
    Amount: yup
      .number()
      .typeError('Amount must be a number')
      .integer('Amount must be an integer')
      .positive('Amount must be greater than zero')
      .required('Amount is required'),
    Meter: yup
      .string()
      .trim()
      .required('Meter number must be a non empty string'),
    Disco: yup
      .string()
      .trim()
      .required('Disco must be a non empty string'),
    'Payment Type': yup
      .string()
      .trim()
      .required('Payment Type must be a non empty string'),
    Phone: yup
      .string()
      .trim()
      .required('Phone number is required')
      .matches(/^(?:\+234|0)[789][01]\d{8}$/, 'Invalid Nigerian phone number'),
    'Vend Type': yup
      .string()
      .trim()
      .required('Vend Type must be a non empty string'),
    Vertical: yup
      .string()
      .trim()
      .required('Vertical must be a non empty string'),
  }),

  config: {
    MAX_BATCH_ORDER_PAYLOAD_SIZE: 1000,
  },
};
